import React, { useEffect, useState } from "react";

const Modal = ({ isOpen, onClose, children }) => {
  const [show, setShow] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setShow(true);
    } else {
      setTimeout(() => setShow(false), 300); // Delay for smooth transition
    }
  }, [isOpen]);

  if (!show) return null;

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 transition-opacity ${isOpen ? "opacity-100" : "opacity-0"
        }`}
      onClick={onClose} // Close modal when clicking on the background
    >
      <div
        className={`bg-white p-4 rounded-2xl shadow-2xl w-[99%] md:w-[98%] lg:w-[95%] xl:w-[95%]
 overflow-y-auto relative transform transition-all ${isOpen ? "scale-100 opacity-100" : "scale-95 opacity-0"
          }`}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
        role="dialog"
        aria-hidden={!isOpen}
      >
        {/* Modal Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-3xl font-bold text-gray-800">
            Customer Scheme Details
          </h2>
          <button
            onClick={onClose}
            className="bg-[#1C50A3] text-white w-8 h-8 flex items-center justify-center rounded-full text-2xl font-bold focus:outline-none hover:bg-[#16448A] transition"
            aria-label="Close modal"
          >
            &times;
          </button>

        </div>

        <hr className="border-gray-300 mb-2" />

        {/* Modal Content */}
        <div className="overflow-y-auto max-h-[80vh] px-2">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
